import { useMemo } from 'react';
import { useOrganizationReadQuery } from '../../queries/admin';
import type { ILegalEntityTable } from '../../types';
import ReadOrganizationNodeResponseManager from '../../services/ReadOrganizationNodeResponseManager';

interface IUseLegalEntities {
  organizationId: string;
  isEnabled?: boolean;
}

interface IUseLegalEntitiesResult {
  legalEntities: ILegalEntityTable[];
  isLoading: boolean;
}

const useLegalEntities = ({ organizationId, isEnabled = true }: IUseLegalEntities): IUseLegalEntitiesResult => {
  const { isFetching, data: organizationData } = useOrganizationReadQuery({ id: organizationId }, isEnabled);

  const legalEntities = useMemo(() => {
    if (!organizationData) return [];

    const organizationManager = new ReadOrganizationNodeResponseManager(organizationData);
    return organizationManager.GetLegalEntityTableData();
  }, [organizationData]);

  return {
    isLoading: isFetching,
    legalEntities,
  };
};

export default useLegalEntities;
